import Axios from 'axios'

const billings = {
  axios() {
    let AxiosInstance = Axios
    AxiosInstance.defaults.baseURL = process.env.BILLINGS_v2
    return AxiosInstance
  },
  getInvoiceList(actualPage, referenceDate) {
    const page = actualPage
    const limit = 20
    const yearMonth = referenceDate
    return this.axios().get(`/list/month?page=${page}&limit=${limit}&yearMonth=${yearMonth}`)
  },
  getInvoiceData(filter, invoiceId, page) {
    return this.axios().post(`/leia/billings/aol/${invoiceId}?page=${page - 1}`, filter)
  },
  downloadInvoice(invoice) {
    return this.axios().get(`/invoice?documentyType=doc${invoice.type}&invoiceNumber=${invoice.number}`)
  },
  getNoteData(note) {
    return this.axios().get(`/note?noteNumber=${note.noteNumber}&rpsNumber=${note.rpsNumber}`)
  },
  getTicketData(ticket, walletType) {
    if (walletType === 'PREPAID') {
      return this.axios().get(`/leia/payments/details/ticket?ticket_number=${ticket}`)
    } else {
      return this.axios().get(`/ticket?ticketNumber=${ticket}`)
    }
  },
  getNegotiatedPriceList() {
    return this.axios().get('/negotiatePrice')
  },
  downloadExamTableAsPDF() {
    return this.axios().get('/priceReport', {
      responseType: 'arraybuffer'
    })
  }
}

export default billings
